import {
  Home, Package, ShoppingBag, Users, Images, StickyNote, Send,
  CreditCard, Clock, Settings, TrendingUp, FolderTree, HelpCircle,
} from 'lucide-react';

/* Единый конфиг навигации админки — его используют боковое меню (веб/десктоп)
   и страница «Ещё» (телефон/мини-апп), чтобы состав и порядок разделов
   больше не могли разойтись между версиями. */

// Верхняя группа — ежедневная работа.
export const NAV_MAIN = [
  { path: '/admin', label: 'Главная', Icon: Home, end: true },
  { path: '/admin/orders', label: 'Заказы', Icon: ShoppingBag },
  { path: '/admin/products', label: 'Товары', Icon: Package },
  { path: '/admin/categories', label: 'Категории', Icon: FolderTree, ownerOnly: true },
  { path: '/admin/users', label: 'Клиенты', Icon: Users, ownerOnly: true },
  { path: '/admin/broadcast', label: 'Рассылки', Icon: Send, ownerOnly: true },
];

// Нижняя группа — «Сайт и администрирование» (в сайдбаре — отдельным блоком
// у самого низа, как на рисунке пользователя). Статистика — только владелец:
// менеджеру она не нужна (дословно, 2026-11-02).
export const NAV_SECONDARY = [
  { path: '/admin/stats', label: 'Статистика', Icon: TrendingUp, ownerOnly: true },
  { path: '/admin/site-photos', label: 'Фото питомника', Icon: Images, ownerOnly: true },
  { path: '/admin/notes', label: 'Заметки', Icon: StickyNote, ownerOnly: true },
  { path: '/admin/team', label: 'Команда', Icon: Users, ownerOnly: true },
  { path: '/admin/subscription', label: 'Подписка', Icon: CreditCard, ownerOnly: true },
  { path: '/admin/activity', label: 'Журнал изменений', Icon: Clock },
  { path: '/admin/settings', label: 'Настройки', Icon: Settings, ownerOnly: true },
  { path: '/admin/faq', label: 'Справка FAQ', Icon: HelpCircle, ownerOnly: true },
];
